import { localStorageKeys } from './consts/localStorage';
import { getParsedParams, paramsKeys } from './consts/params';

const carryThroughKeys: Readonly<Array<keyof typeof paramsKeys>> = [
  'FUNNEL',
  'CLICK_ID',
  'UTM_SOURCE',
  'UTM_MEDIUM',
  'UTM_CAMPAIGN',
  'AD_SET',
  'SHORTCUT',
  'AD_GROUP_ID',
  'APP_IDENTITY',
  // these few below are non URL-params ones, should get them from state
  'PROMOCODE',
  'PLAN',
] as const;

export const collectCarryThroughParams = ({
  code,
  plan,
}: {
  code?: string;
  plan?: string;
}): Record<(typeof paramsKeys)[(typeof carryThroughKeys)[number]], string> => {
  const urlParams = getParsedParams();

  const returnParams = carryThroughKeys.reduce(
    (acc, cur) => {
      const param = urlParams[cur];

      if (param) {
        acc[paramsKeys[cur]] = param;
      }

      return acc;
    },
    {} as Record<(typeof paramsKeys)[(typeof carryThroughKeys)[number]], string>,
  );

  if (!returnParams.clickid && urlParams.IR_CLICK_ID) {
    returnParams.clickid = urlParams.IR_CLICK_ID;
  }

  if (code) {
    returnParams.code = code;
  }

  if (plan) {
    returnParams.plan = plan;
  }

  return returnParams;
};

export const saveOAuthParams = (selectedPlanSku: string) => {
  localStorage.setItem(localStorageKeys.AFFILIATE_OAUTH_PARAMS, window.location.search);
  localStorage.setItem(localStorageKeys.SELECTED_PLAN_SKU, selectedPlanSku);
};

export const extractOAuthParams = () => localStorage.getItem(localStorageKeys.AFFILIATE_OAUTH_PARAMS);

export const removeOAuthParams = () => {
  localStorage.removeItem(localStorageKeys.AFFILIATE_OAUTH_PARAMS);
};
